'use strict';

import type { CommissionStatementMapping } from '../../Entities/CommissionStatement/CommissionStatementMapping';
import { EntityCollection } from '../EntityCollection';

export class CommissionStatementMappingCollection extends EntityCollection<CommissionStatementMapping> {}
